module.exports = __webpack_public_path__ + "static/img/helpCenter.b1c0e0d1.png";